import { Form } from "antd";
import { translate } from "../../../core";
import { NumericInput } from "../../../core/component";
import { InputCard } from "./InputCard";

export const ItemFormQuantity = () => {
  return (
    <InputCard
      title={translate("quantity")}
      className="py-0 mb-0 mt-4"
      contained
    >
      <div className="d-flex gap-2 mt-2" style={{height: '5rem'}}>
        <Form.Item name={["quantity", "onHand"]} label={translate("on_hand")}>
          <NumericInput decimalPlaces={0} className="w-100" />
        </Form.Item>
        <Form.Item name={["quantity", "display"]} label={translate("display")}>
          <NumericInput decimalPlaces={0} className="w-100" />
        </Form.Item>
      </div>
      <div className="d-flex gap-2" style={{height: '5rem'}}>
        <Form.Item name={["quantity", "onOrder"]} label={translate("on_order")}>
          <NumericInput
            disabled
            decimalPlaces={0}
            className="w-100"
          />
        </Form.Item>
        <Form.Item
          name={["quantity", "backOrder"]}
          label={translate("back_order")}
        >
          <NumericInput
            disabled
            decimalPlaces={0}
            className="w-100"
          />
        </Form.Item>
      </div>
      <div className="d-flex gap-2" style={{height: '5rem'}}>
        <Form.Item name={["quantity", "inSet"]} label={translate("in_set")}>
          <NumericInput decimalPlaces={0} className="w-100" />
        </Form.Item>
        <Form.Item
          name={["quantity", "committed"]}
          label={translate("committed")}
        >
          <NumericInput decimalPlaces={0} className="w-100" />
        </Form.Item>
      </div>
      <div className="d-flex gap-2" >
        <Form.Item name={["quantity", "min"]} label={translate("min")}>
          <NumericInput decimalPlaces={0} className="w-100" />
        </Form.Item>
        <Form.Item name={["quantity", "max"]} label={translate("max")}>
          <NumericInput decimalPlaces={0} className="w-100" />
        </Form.Item>
      </div>
    </InputCard>
  );
};
